import AdOps from "./AdOps";

export default AdOps;
